import yup from 'utils/yup';

import { PropertyFormValues } from '../../types';

export const propertyFormSchema = (isAgent: boolean) => {
  const formFields: Omit<PropertyFormValues, 'type' | 'tags'> = {
    name: yup.string().required('Name is required'),
    countryId: yup.string().required('Country is required').nullable(),
    coords: yup.string().required('Coordinates is required'),
    address: yup.string().required('Address is required'),
    area: yup
      .object()
      .shape({
        name: yup.string().nullable().required('Area is required'),
        id: yup.string().nullable(),
        confirmed: yup.boolean().nullable(),
      })
      .required('Area is required')
      .nullable(),
  };

  if (isAgent) {
    formFields.masterProperty = yup.object().shape({
      name: yup.string().required('Master Property is required'),
      id: yup.string().nullable(),
    });
  } else {
    formFields.masterProperty = yup.object().shape({
      name: yup.string().nullable(),
      id: yup.string().nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};
